import { render, staticRenderFns } from "./FormCourseSetSelect.vue?vue&type=template&id=5e8eb544&scoped=true&"
import script from "./FormCourseSetSelect.vue?vue&type=script&lang=js&"
export * from "./FormCourseSetSelect.vue?vue&type=script&lang=js&"
import style0 from "./FormCourseSetSelect.vue?vue&type=style&index=0&id=5e8eb544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8eb544",
  null
  
)

export default component.exports